<template>
  <header class="header" :class="{ open }">
    <div class="container bar">
      <a href="/" class="brand" aria-label="엔케이시스템 홈" @click.prevent="goTop">
        <img :src="logo" alt="엔케이시스템(주)" class="logo" />
      </a>

      <nav class="nav" aria-label="주 메뉴">
        <a v-for="item in items" :key="item.id" :href="'#' + item.id" class="nav-link" :class="{ active: active === item.id }" @click.prevent="go(item.id)">{{ item.label }}</a>
        <a :href="mailto" class="btn btn-primary btn-sm nav-cta">문의하기</a>
      </nav>

      <button class="burger" type="button" :aria-expanded="open ? 'true' : 'false'" aria-label="메뉴 열기" @click="open = !open">
        <svg v-if="!open" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M4 7h16M4 12h16M4 17h16" /></svg>
        <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18" /></svg>
      </button>
    </div>

    <transition name="drop">
      <nav v-if="open" class="mobile-nav" aria-label="모바일 메뉴">
        <a v-for="item in items" :key="item.id" :href="'#' + item.id" class="mobile-link" :class="{ active: active === item.id }" @click.prevent="go(item.id)">{{ item.label }}</a>
        <a :href="mailto" class="btn btn-primary" @click="open = false">문의하기</a>
      </nav>
    </transition>
  </header>
</template>

<script>
import { company } from '@/data/company';
import { sections, scrollToSection } from '@/scroll';

export default {
  name: 'SiteHeader',
  data() {
    return {
      open: false,
      mailto: 'mailto:' + company.email,
      logo: require('@/assets/logo.png'),
      items: sections,
      active: '',
    };
  },
  watch: {
    $route() { this.open = false; },
  },
  mounted() {
    if (!('IntersectionObserver' in window)) return;
    this.io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) this.active = e.target.id; });
    }, { rootMargin: '-40% 0px -55% 0px', threshold: 0 });
    this.observe();
    this.$router.afterEach(() => { this.$nextTick(() => this.observe()); });
  },
  beforeUnmount() { if (this.io) this.io.disconnect(); },
  methods: {
    observe() {
      if (!this.io) return;
      this.io.disconnect();
      sections.forEach((s) => { const el = document.getElementById(s.id); if (el) this.io.observe(el); });
    },
    go(id) {
      this.open = false;
      if (this.$route.path !== '/') { this.$router.push({ path: '/', hash: '#' + id }); return; }
      scrollToSection(id);
      history.replaceState(null, '', '#' + id);
    },
    goTop() {
      this.open = false;
      if (this.$route.path !== '/') { this.$router.push('/'); return; }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      history.replaceState(null, '', '/');
    },
  },
};
</script>

<style scoped>
.header { position: sticky; top: 0; z-index: 50; background: var(--navy); border-bottom: 1px solid rgba(255,255,255,0.08); }
.bar { height: 72px; display: flex; align-items: center; justify-content: space-between; gap: 16px; }
.brand { display: inline-flex; background: #ffffff; border-radius: 6px; padding: 6px 10px; }
.logo { height: 32px; width: auto; }
.nav { display: flex; align-items: center; gap: 32px; }
.nav-link { color: #cbd5e1; font-size: 15px; font-weight: 500; padding: 6px 0; border-bottom: 2px solid transparent; transition: color .15s ease, border-color .15s ease; }
.nav-link:hover { color: #ffffff; }
.nav-link.active { color: #ffffff; border-bottom-color: var(--orange); }
.nav-cta { margin-left: 8px; }
.burger { display: none; background: none; border: 0; color: #e2e8f0; padding: 8px; cursor: pointer; }
.mobile-nav { display: none; }

@media (max-width: 900px) {
  .bar { height: 60px; }
  .logo { height: 26px; }
  .nav { display: none; }
  .burger { display: inline-flex; }
  .mobile-nav { display: flex; flex-direction: column; gap: 4px; padding: 8px 20px 20px 20px; background: var(--navy); border-top: 1px solid rgba(255,255,255,0.08); }
  .mobile-link { color: #e2e8f0; font-size: 17px; font-weight: 500; padding: 14px 4px; border-bottom: 1px solid rgba(255,255,255,0.08); }
  .mobile-link.active { color: var(--orange); }
  .mobile-nav .btn { margin-top: 12px; }
  .drop-enter-active, .drop-leave-active { transition: opacity .18s ease, transform .18s ease; }
  .drop-enter-from, .drop-leave-to { opacity: 0; transform: translateY(-6px); }
}
</style>
